import { VectorEditorStickerFreePCF } from '../Function/module/VectorEditorStickerFreePCF.js';

export const handleNewStickerButtonClick =
  ({ tab_el }) =>
  () =>
    VectorEditorStickerFreePCF.addNewSticker({ tab_el });
